import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';

export const TAB_COMMUNITY = '#community';
export const TAB_HORSE_PROFILE = '#pferde-profile';

export const useSelectedContentTab = () => {
    const history = useHistory();
    const { hash } = history.location;

    const [contentTab, setContentTab] = useState(null);

    const navigateToTab = tab =>
        history.push(
            createResourceLocatorString('GuidlinePage', routeConfiguration(), {}, {}, tab)
        );

    useEffect(() => {
        if (hash !== TAB_COMMUNITY && hash !== TAB_HORSE_PROFILE) {
            return history.push(
                createResourceLocatorString(
                    'GuidlinePage',
                    routeConfiguration(),
                    {},
                    {},
                    TAB_COMMUNITY
                )
            );
        }
        setContentTab(hash);
    }, [hash]);

    return { contentTab, navigateToTab };
};
